import { omit } from 'lodash';

import { Deserializer, makeQueryStringSerializer } from 'core/lib/serializer';
import apiFetch from 'core/ovations-api/apiFetch';
import { API_URL } from 'core/ovations-api/constants';
import * as Types from 'core/ovations-api/definitions';

const baseUrl = (clientId: string, programId: string): string => {
    return `${API_URL}/api/v1/client/${clientId}/program/${programId}/SalesIncentive`;
};

const defaultRequest: Partial<Types.SalesIncentiveSearchRequest> = {
    page: 1,
    states: [],
    origin: 'Start',
};

const serializer = makeQueryStringSerializer<Types.SalesIncentiveSearchRequest>(defaultRequest, {
    page: Deserializer.Int,
    sortDescending: Deserializer.Bool,
});

export default class SalesIncentive {
    static defaultRequest = defaultRequest;

    static serializeRequest = serializer.serialize;

    static deserializeRequest = serializer.deserialize;

    static async fetch(clientId: string, programId: string, salesIncentiveId: string) {
        const response = await apiFetch(`${baseUrl(clientId, programId)}/${salesIncentiveId}`);
        const salesIncentive: Types.SalesIncentive = await response.json();
        return salesIncentive;
    }

    static async create(clientId: string, programId: string, salesIncentive: Types.SalesIncentive) {
        const response = await apiFetch(baseUrl(clientId, programId), {
            headers: [['Content-Type', 'application/json']],
            method: 'POST',
            body: JSON.stringify(omit(salesIncentive, 'id')),
        });
        const newSalesIncentive: Types.SalesIncentive = await response.json();
        return newSalesIncentive;
    }

    static async update(clientId: string, programId: string, salesIncentive: Types.SalesIncentive) {
        await apiFetch(baseUrl(clientId, programId), {
            headers: [['Content-Type', 'application/json']],
            method: 'PUT',
            body: JSON.stringify(salesIncentive),
        });
    }

    static async search(
        clientId: string,
        programId: string,
        salesIncentiveSearchRequest: Partial<Types.SalesIncentiveSearchRequest>,
    ): Promise<Types.SearchResultsResponse<Types.SalesIncentive>> {
        const query = SalesIncentive.serializeRequest(salesIncentiveSearchRequest, true);
        const response = await apiFetch(`${baseUrl(clientId, programId)}?${query}`);
        const salesIncentives: Types.SearchResultsResponse<Types.SalesIncentive> = await response.json();
        return salesIncentives;
    }
}
